<template>
  <div class="container py-4">
    <h2 class="mb-4">Apps</h2>

    <div class="card shadow-sm">
      <div class="card-body d-flex flex-column flex-md-row justify-content-between align-items-md-center">
        <div>
          <h5 class="card-title mb-1">Tera Scanner App</h5>
          <p class="card-text text-muted mb-2">Latest APK for the handheld scanner</p>
        </div>

        <button
          class="btn btn-success mt-2 mt-md-0 d-flex align-items-center"
          @click="downloadApk('app-debug-latest')"
          :disabled="downloading"
        >
          <i
            v-show="downloading"
            class="fas fa-spinner fa-spin me-2"
          ></i>
          <i
            v-show="!downloading"
            class="fas fa-download me-2 mr-2"
          ></i>
          {{ downloading ? "Downloading..." : "Download App" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppDownload",
  data() {
    return {
      downloading: false
    };
  },
  methods: {
    async downloadApk(appname) {
      this.downloading = true;
      try {
        await this.$store.dispatch("Apps/downloadApk", { appname });
      } catch (error) {
        console.error("Download error:", error);
      } finally {
        this.downloading = false;
      }
    }
  }
};
</script>
